import React from "react";
import Pagination from "react-js-pagination";
import ContentTable from "./ContentTable";
import BtnThemMoi from "./ThemMoi/BtnThemMoi";

export const TableDanhSach = ({ phanQuyen, listDanhSach, isLoading, dataSearch, setDataSearch, onSearch, onReload }) => {
  const handlePageChange = (pageNumber) => {
    setDataSearch(prev => ({ ...prev, PageIndex: pageNumber }));
    onSearch({ ...dataSearch, PageIndex: pageNumber });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  return (
    <>
      {isLoading ? (
        <div className="loading-page1">
          <div className="loader loader-default is-active"></div>
        </div>
      ) : (
        <>
          <div className="card border-light mb-2 card-v2">
            <div className="card-body card-body-v2">
              <div className="row col-sm-12 col-md-12 themoi-taisanthanhly mb-1">
                <div className="col-sm-12 col-md-10">
                  {phanQuyen.themmoi && <BtnThemMoi onReload={onReload} />}
                </div>
              </div>
              <div className="Left808x200 Table-main-new css-table-ds">
                <div className="table-mobile table-mobile-hover">
                  <div className="custom-table-wrapper" style={{ overflowX: "auto", width: '100%' }}>
                    <div className="table-headers">
                      <div className="custom-table-header flex-basis-5 text-left" style={{ justifyContent: 'flex-start' }}>
                        <p className="color-do-bold">
                          STT
                          <br />[{listDanhSach.iTotal}]
                        </p>
                      </div>
                      <div className="custom-table-header flex-basis-70 text-center" style={{ justifyContent: 'flex-center' }}>
                        <p>Tên hợp đồng</p>
                      </div>
                      <div className="custom-table-header flex-basis-25 text-center">
                        <p>Chức năng</p>
                      </div>
                    </div>

                    <div className="custom-table-body">
                      <ContentTable 
                        listDanhSach={listDanhSach.List}
                        phanQuyen={phanQuyen}
                        onReload={onReload}
                        PageIndex={dataSearch.PageIndex}
                        PageSize={dataSearch.PageSize}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card border-light mb-2 card-v2" >
            <div className="card-body card-body-v2">
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <span className="color7">
                    {listDanhSach.iTotal === 0 ? (
                      "Hiển thị 0 - 0 / Tổng số 0"
                    ) : (
                      <>
                        Hiển thị{" "}
                        {(dataSearch.PageIndex - 1) * dataSearch.PageSize + 1} -{" "}
                        {Math.min(
                          dataSearch.PageIndex * dataSearch.PageSize,
                          listDanhSach.iTotal
                        )}{" "}
                        / Tổng số {listDanhSach.iTotal}
                      </>
                    )}
                  </span>
                </div>
                <div className="col-sm-12 col-md-6">
                  <div
                    className={
                      "paniation-new paniation-new1 d-flex justify-content-center " +
                      (listDanhSach.iTotal === 0 ? "hidden" : "")
                    }
                    style={{ float: "right" }}
                  >
                    <nav aria-label="Page navigation">
                      <Pagination
                        activePage={dataSearch.PageIndex}
                        itemsCountPerPage={dataSearch.PageSize}
                        totalItemsCount={listDanhSach.iTotal}
                        pageRangeDisplayed={5}
                        onChange={handlePageChange}
                        itemClass="page-item border-none"
                        linkClass="page-link border-none"
                        activeClass="active"
                      />
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TableDanhSach;